export const ORIGIN_OPTIONS = [
  { value: "v5", label: "V5" },
  { value: "wialon", label: "WIALON" },
  { value: "mapon", label: "MAPON" },
];

const EMPTY_ADDR = {
  business_name: "",
  first_address: "",
  second_address: "",
  city: "",
  state: "",
  zip_code: "",
  country: "",
  phone: "",
  email: "",
};

export function emptyUsuarioForm() {
  return {
    user_name: "",
    company: "",
    first_name: "",
    last_name: "",
    user_status_id: "",
    account_condition_id: "",
    map_interval: 4,
    not_reporting_alert: true,
    origin: [] as string[],
    v5_email: "",
    v5_username: "",
    v5_password: "",
    billing: { ...EMPTY_ADDR, tax_id: "" },
    contact: { ...EMPTY_ADDR },
  };
}

export function normalizeOrigin(origin: string[] | null | undefined): string[] {
  const allowed = new Set(ORIGIN_OPTIONS.map((o) => o.value));
  return [...new Set((origin ?? []).filter((v) => allowed.has(v)))];
}

export function toUsuarioForm({ user, billing, contact }: any) {
  return {
    user_name: user.user_name ?? "",
    company: user.company ?? "",
    first_name: user.first_name ?? "",
    last_name: user.last_name ?? "",
    user_status_id: user.user_status_id ?? "",
    account_condition_id: user.account_condition_id ?? "",
    map_interval: user.map_interval ?? "",
    not_reporting_alert: !!user.not_reporting_alert,
    origin: normalizeOrigin(user.origin),
    billing: billing ?? { ...EMPTY_ADDR, tax_id: "" },
    contact: contact ?? { ...EMPTY_ADDR },
  };
}

export function toUsuarioPayload(values: any) {
  return {
    user_name: values.user_name || null,
    company: values.company || null,
    first_name: values.first_name || null,
    last_name: values.last_name || null,
    user_status_id: values.user_status_id || null,
    account_condition_id: values.account_condition_id || null,
    map_interval:
      values.map_interval === "" || values.map_interval == null
        ? null
        : Number(values.map_interval),
    not_reporting_alert: !!values.not_reporting_alert,
    origin: normalizeOrigin(values.origin),
  };
}

export function hasAddressData(addr: Record<string, any>): boolean {
  return Object.entries(addr).some(
    ([k, v]) =>
      !["id", "user_id", "created_at", "updated_at"].includes(k) && v
  );
}

export function toAddressPayload(addr: Record<string, any>) {
  const { id, user_id, created_at, updated_at, ...rest } = addr;
  void id;
  void user_id;
  void created_at;
  void updated_at;
  return Object.fromEntries(
    Object.entries(rest).map(([k, v]) => [k, v === "" ? null : v])
  );
}

const EMPTY_DEVICE = {
  uniq_id: "",
  name: "",
  user_id: "",
  status_id: "",
  device_condition_id: "",
  car_image_id: "",
  simcard: "",
  phone: "",
  imei: "",
  ip: "",
  speed_alert: "",
  installation: "",
  activation: "",
  brand_id: "",
  plates: "",
  type_id: "",
  brand: "",
  model: "",
};

export function emptyEquipoForm() {
  return { ...EMPTY_DEVICE };
}

export function toEquipoForm(device: any) {
  return {
    ...EMPTY_DEVICE,
    ...device,
    device_condition_id: device.device_condition_id ?? "",
    brand_id: device.brand_id ?? "",
    type_id: device.type_id ?? "",
    brand: device.brand ?? "",
    model: device.model ?? "",
    installation: device.installation ?? "",
    activation: device.activation ?? "",
  };
}

export function toDevicePayload(values: any) {
  const num = (v: any) => (v === "" || v == null ? null : Number(v));
  const txt = (v: any) => (v === "" || v == null ? null : v);
  return {
    uniq_id: txt(values.uniq_id),
    name: txt(values.name),
    user_id: num(values.user_id),
    status_id: num(values.status_id),
    device_condition_id: num(values.device_condition_id),
    car_image_id: num(values.car_image_id),
    simcard: txt(values.simcard),
    phone: txt(values.phone),
    imei: txt(values.imei),
    ip: txt(values.ip),
    speed_alert: num(values.speed_alert),
    installation: txt(values.installation),
    activation: txt(values.activation),
    brand_id: num(values.brand_id),
    plates: txt(values.plates),
    type_id: num(values.type_id),
    brand: txt(values.brand),
    model: txt(values.model),
  };
}
